
export const platformConstants = {
    theOpen: 'TheOpen',
    womensOpen: 'AIGWO',
};
